import { createFileRoute } from '@tanstack/react-router'
import { VerifySuratPage } from './$kode.page'

export const Route = createFileRoute('/verify/$kode')({
  component: VerifySuratRoute,
})

function VerifySuratRoute() {
  const { kode } = Route.useParams()
  return <VerifySuratPage kode={kode} />
}
